// src/components/dashboard/Leaderboards/TopWinners.jsx
// src/components/dashboard/Leaderboards/TopWinners.jsx
import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { Avatar, Box, Typography, Chip, alpha, useTheme } from '@mui/material';
import { EmojiEvents, TrendingUp } from '@mui/icons-material';
import { formatCurrency, formatPhone } from '../../../utils/formatters';

const TopWinners = () => {
  const theme = useTheme();
  const { leaderboards, loading } = useSelector((state) => state.dashboard);

  const columns = [
    {
      field: 'rank',
      headerName: '#',
      width: 60,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              background: params.row.id <= 3 
                ? `linear-gradient(135deg, #FFD700 0%, #FFA000 100%)`
                : alpha(theme.palette.primary.main, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              color: params.row.id <= 3 ? 'white' : 'text.primary',
            }}
          >
            {params.row.id <= 3 ? <EmojiEvents sx={{ fontSize: '1rem' }} /> : params.row.id}
          </Box>
        </Box>
      ),
    },
    {
      field: 'phone',
      headerName: 'Player',
      width: 160,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'primary.main',
              fontSize: '0.875rem',
              fontWeight: 'bold',
            }}
          >
            {params.value.slice(-4)}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
            {formatPhone(params.value)}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'win',
      headerName: 'Winnings',
      width: 120,
      type: 'number',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#4CAF50' }}>
            {formatCurrency(params.value)}
          </Typography>
          <TrendingUp sx={{ fontSize: '0.875rem', color: '#4CAF50' }} />
        </Box>
      ),
    },
    {
      field: 'games',
      headerName: 'Games',
      width: 100,
      type: 'number',
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          sx={{
            background: alpha(theme.palette.info.main, 0.1),
            color: theme.palette.info.main,
            fontWeight: 600,
            fontSize: '0.75rem',
            height: 24,
          }}
        />
      ),
    },
  ];

  // Add rank to data
  const rowsWithRank = leaderboards.topWinners.map((row, index) => ({
    ...row,
    rank: index + 1,
  }));

  return (
    <DataGrid
      rows={rowsWithRank}
      columns={columns}
      loading={loading}
      autoHeight
      hideFooter
      disableRowSelectionOnClick
      disableColumnMenu
      sx={{
        border: 'none',
        '& .MuiDataGrid-columnHeaders': {
          bgcolor: alpha(theme.palette.secondary.main, 0.05),
          borderRadius: '12px 12px 0 0',
          fontWeight: 700,
          fontSize: '0.875rem',
          color: 'text.primary',
          borderBottom: `2px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
        },
        '& .MuiDataGrid-columnHeader': {
          outline: 'none',
          '&:focus': { outline: 'none' },
        },
        '& .MuiDataGrid-cell': {
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
          outline: 'none',
          '&:focus': { outline: 'none' },
        },
        '& .MuiDataGrid-row': {
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: alpha(theme.palette.secondary.main, 0.04),
            transform: 'translateX(4px)',
          },
          '&:nth-of-type(odd)': {
            bgcolor: alpha(theme.palette.grey[100], theme.palette.mode === 'dark' ? 0.02 : 0.3),
          },
        },
      }}
    />
  );
};

export default TopWinners;


// // src/components/dashboard/Leaderboards/TopWinners.jsx
// import React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import { useSelector } from 'react-redux';
// import { Avatar, Box, Typography, Chip, alpha, useTheme } from '@mui/material';
// import { EmojiEvents, TrendingUp } from '@mui/icons-material';
// import { formatCurrency, formatPhone } from '../../../utils/formatters';

// const TopWinners = () => {
//   const theme = useTheme();
//   const { leaderboards, loading } = useSelector((state) => state.dashboard);

//   const columns = [
//     {
//       field: 'rank',
//       headerName: '#',
//       width: 60,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Box
//             sx={{
//               width: 32,
//               height: 32,
//               borderRadius: '50%',
//               background: params.row.id <= 3 
//                 ? `linear-gradient(135deg, #FFD700 0%, #FFA000 100%)`
//                 : alpha(theme.palette.primary.main, 0.1),
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '0.875rem',
//               color: params.row.id <= 3 ? 'white' : 'text.primary',
//             }}
//           >
//             {params.row.id <= 3 ? <EmojiEvents sx={{ fontSize: '1rem' }} /> : params.row.id}
//           </Box>
//         </Box>
//       ),
//     },
//     {
//       field: 'phone',
//       headerName: 'Player',
//       width: 160,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           <Avatar
//             sx={{
//               width: 32,
//               height: 32,
//               bgcolor: 'primary.main',
//               fontSize: '0.875rem',
//               fontWeight: 'bold',
//             }}
//           >
//             {params.value.slice(-4)}
//           </Avatar>
//           <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
//             {formatPhone(params.value)}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'win',
//       headerName: 'Winnings',
//       width: 120,
//       type: 'number',
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Typography variant="body2" sx={{ fontWeight: 700, color: '#4CAF50' }}>
//             {formatCurrency(params.value)}
//           </Typography>
//           <TrendingUp sx={{ fontSize: '0.875rem', color: '#4CAF50' }} />
//         </Box>
//       ),
//     },
//     {
//       field: 'games',
//       headerName: 'Games',
//       width: 100,
//       type: 'number',
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           size="small"
//           sx={{
//             background: alpha(theme.palette.info.main, 0.1),
//             color: theme.palette.info.main,
//             fontWeight: 600,
//             fontSize: '0.75rem',
//             height: 24,
//           }}
//         />
//       ),
//     },
//   ];

//   // Add rank to data
//   const rowsWithRank = leaderboards.topWinners.map((row, index) => ({
//     ...row,
//     rank: index + 1,
//   }));

//   return (
//     <DataGrid
//       rows={rowsWithRank}
//       columns={columns}
//       loading={loading}
//       autoHeight
//       hideFooter
//       disableRowSelectionOnClick
//       disableColumnMenu
//       sx={{
//         border: 'none',
//         '& .MuiDataGrid-columnHeaders': {
//           bgcolor: alpha(theme.palette.secondary.main, 0.05),
//           borderRadius: '12px 12px 0 0',
//           fontWeight: 700,
//           fontSize: '0.875rem',
//           color: 'text.primary',
//           borderBottom: `2px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
//         },
//         '& .MuiDataGrid-columnHeader': {
//           outline: 'none',
//           '&:focus': { outline: 'none' },
//         },
//         '& .MuiDataGrid-cell': {
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
//           outline: 'none',
//           '&:focus': { outline: 'none' },
//         },
//         '& .MuiDataGrid-row': {
//           transition: 'all 0.2s ease',
//           cursor: 'pointer',
//           '&:hover': {
//             bgcolor: alpha(theme.palette.secondary.main, 0.04),
//             transform: 'translateX(4px)',
//           },
//           '&:nth-of-type(odd)': {
//             bgcolor: alpha(theme.palette.grey[100], theme.palette.mode === 'dark' ? 0.02 : 0.3),
//           },
//         },
//       }}
//     />
//   );
// };

// export default TopWinners;


// // src/components/dashboard/Leaderboards/TopWinners.jsx
// import React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import { useSelector } from 'react-redux';
// import { Avatar, Box, Typography, Chip, alpha, useTheme } from '@mui/material';
// import { EmojiEvents, TrendingUp } from '@mui/icons-material';
// import { formatCurrency, formatPhone } from '../../../utils/formatters';

// const TopWinners = () => {
//   const theme = useTheme();
//   const { leaderboards, loading } = useSelector((state) => state.dashboard);

//   const columns = [
//     {
//       field: 'rank',
//       headerName: '#',
//       width: 60,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Box
//             sx={{
//               width: 32,
//               height: 32,
//               borderRadius: '50%',
//               background: params.row.id <= 3 
//                 ? `linear-gradient(135deg, #FFD700 0%, #FFA000 100%)`
//                 : alpha(theme.palette.primary.main, 0.1),
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '0.875rem',
//               color: params.row.id <= 3 ? 'white' : 'text.primary',
//             }}
//           >
//             {params.row.id <= 3 ? <EmojiEvents sx={{ fontSize: '1rem' }} /> : params.row.id}
//           </Box>
//         </Box>
//       ),
//     },
//     {
//       field: 'phone',
//       headerName: 'Player',
//       width: 160,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           <Avatar
//             sx={{
//               width: 32,
//               height: 32,
//               bgcolor: 'primary.main',
//               fontSize: '0.875rem',
//               fontWeight: 'bold',
//             }}
//           >
//             {params.value.slice(-4)}
//           </Avatar>
//           <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
//             {formatPhone(params.value)}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'win',
//       headerName: 'Winnings',
//       width: 120,
//       type: 'number',
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Typography variant="body2" sx={{ fontWeight: 700, color: '#4CAF50' }}>
//             {formatCurrency(params.value)}
//           </Typography>
//           <TrendingUp sx={{ fontSize: '0.875rem', color: '#4CAF50' }} />
//         </Box>
//       ),
//     },
//     {
//       field: 'games',
//       headerName: 'Games',
//       width: 100,
//       type: 'number',
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           size="small"
//           sx={{
//             background: alpha(theme.palette.info.main, 0.1),
//             color: theme.palette.info.main,
//             fontWeight: 600,
//             fontSize: '0.75rem',
//             height: 24,
//           }}
//         />
//       ),
//     },
//   ];

//   // Add rank to data
//   const rowsWithRank = leaderboards.topWinners.map((row, index) => ({
//     ...row,
//     rank: index + 1,
//   }));

//   return (
//     <DataGrid
//       rows={rowsWithRank}
//       columns={columns}
//       loading={loading}
//       autoHeight
//       hideFooter
//       disableRowSelectionOnClick
//       disableColumnMenu
//       sx={{
//         border: 'none',
//         '& .MuiDataGrid-root': {
//           fontSize: '0.875rem',
//         },
//         '& .MuiDataGrid-columnHeaders': {
//           bgcolor: alpha(theme.palette.primary.main, 0.05),
//           borderRadius: '12px 12px 0 0',
//           fontWeight: 700,
//           fontSize: '0.875rem',
//           color: 'text.primary',
//           borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//         },
//         '& .MuiDataGrid-columnHeader': {
//           outline: 'none',
//           '&:focus': {
//             outline: 'none',
//           },
//         },
//         '& .MuiDataGrid-cell': {
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
//           outline: 'none',
//           '&:focus': {
//             outline: 'none',
//           },
//         },
//         '& .MuiDataGrid-row': {
//           transition: 'all 0.2s ease',
//           cursor: 'pointer',
//           '&:hover': {
//             bgcolor: alpha(theme.palette.primary.main, 0.04),
//             transform: 'translateX(4px)',
//           },
//           '&:nth-of-type(odd)': {
//             bgcolor: alpha(theme.palette.grey[100], theme.palette.mode === 'dark' ? 0.02 : 0.3),
//           },
//         },
//       }}
//     />
//   );
// };

// export default TopWinners;

// // src/components/dashboard/Leaderboards/TopWinners.jsx
// import React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import { useSelector } from 'react-redux';
// import { formatCurrency, formatPhone } from '../../../utils/formatters';

// const TopWinners = () => {
//   const { leaderboards, loading } = useSelector((state) => state.dashboard);

//   const columns = [
//     {
//       field: 'phone',
//       headerName: 'Phone',
//       width: 150,
//       valueFormatter: (params) => formatPhone(params.value),
//     },
//     {
//       field: 'win',
//       headerName: 'Win',
//       width: 120,
//       type: 'number',
//       valueFormatter: (params) => formatCurrency(params.value),
//     },
//     {
//       field: 'play',
//       headerName: 'Play',
//       width: 120,
//       type: 'number',
//       valueFormatter: (params) => formatCurrency(params.value),
//     },
//     {
//       field: 'lost',
//       headerName: 'Lost',
//       width: 120,
//       type: 'number',
//       valueFormatter: (params) => formatCurrency(params.value),
//     },
//     {
//       field: 'games',
//       headerName: 'Games',
//       width: 100,
//       type: 'number',
//     },
//   ];

//   return (
//     <DataGrid
//       rows={leaderboards.topWinners}
//       columns={columns}
//       loading={loading}
//       autoHeight
//       hideFooter
//       disableRowSelectionOnClick
//       density="compact"
//       sx={{
//         border: 'none',
//         '& .MuiDataGrid-columnHeaders': {
//           bgcolor: 'action.hover',
//           fontWeight: 600,
//         },
//       }}
//     />
//   );
// };

// export default TopWinners;